import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IAppConfig } from 'src/app/shared/interfaces/app-config';
import { MandateAssessmentStatus } from '../interfaces/mandate-assessment-status';
import { catchError, Observable } from 'rxjs';
import { handleError } from 'src/app/shared/functions/error-handler';
import { assertTrustedUrl } from 'src/app/shared/functions/validate-url';

@Injectable({
  providedIn: 'root',
})
export class CaseloadService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public fetchMandatesAssessments(
    type: string
  ): Observable<MandateAssessmentStatus[]> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/${encodeURI(type)}`,
      this.config.apiUrl
    );
    return this.http
      .get<MandateAssessmentStatus[]>(url)
      .pipe(catchError(handleError));
  }
}
